import authService from "../services/auth-service";
import { transaction } from "../store/labSlice";
import store from "../store/store";
export const fetchData = async ({
  api,
  name,
  key,
  searchParams,
  filterCallback,
  showLoading,
  hideLoading,
  hold,
}) => {
  const state = store?.getState();
  const existingData = state?.lab[name]?.data;
  const existingTotal = state?.lab[name]?.total;
  const existingPages = state?.lab[name]?.pages;
  const pageExists = existingPages?.some((p) => p.page === searchParams?.page);
  if (
    pageExists &&
    filterCallback &&
    existingData &&
    existingData?.length > 0
  ) {
    const filterData = filterCallback(existingData, searchParams);

    if (filterData && filterData?.length > 0) {
      return {
        status: true,
        message: "successfully",
        data: filterData,
        total: existingTotal,
      };
    }
  }

  try {
    showLoading && showLoading();
    const apiData = await authService[api]({ attributes: searchParams });

    const maxId = Math.max(...apiData?.data?.rows.map((item) => item[key]));
    if (hold) {
      store?.dispatch(
        transaction({
          name,
          data: apiData?.data?.rows,
          total: apiData?.data?.total,
          next_last_id: apiData?.data?.next_last_id || maxId,
          key,
          page: searchParams?.page,
        })
      );
    }
    return {
      status: true,
      message: "successfully",
      data: apiData?.data?.rows,
      total: apiData?.data?.total,
    };
  } catch (error) {
    return { status: false, message: error?.message, data: [] };
  } finally {
    hideLoading && hideLoading();
  }
};
